import { t } from '../i18n';

const PERMISSION_ERROR_NAMES = ['NotAllowedError', 'PermissionDeniedError'];

export function isMediaPermissionError(error: unknown): boolean {
  if (error instanceof DOMException && PERMISSION_ERROR_NAMES.includes(error.name)) return true;
  if (error instanceof Error) {
    return PERMISSION_ERROR_NAMES.some((name) => error.message.startsWith(name + ':') || error.message === name);
  }
  return false;
}

export function humanizeCallError(error: unknown): string {
  const message =
    error instanceof Error
      ? String(error.message || '').trim()
      : typeof error === 'string'
        ? error.trim()
        : '';

  switch (message) {
    case 'WS_NOT_READY_FOR_SERVER':
      return t('call.errors.wsReconnectPending');
    case 'SERVER_CONTEXT_SWITCH_TIMEOUT':
      return t('call.errors.serverSwitchTimeout');
    case 'NO_LOCAL_IDENTITY_CONTEXT':
    case 'MISSING_TARGET_IDENTITY':
      return t('call.errors.noIdentityAvailable');
    default:
      return message || t('common.unknownError');
  }
}
